import { onSelectChange } from "@portal/BaseComponents/Select/type";
import { useUpdatePTPStatusQuery } from "@portal/queries/ptp-query";
import { ptpStatusOptions } from "@portal/store/Filters/ptp/predicate";
import { PTPStatus } from "@portal/types/entities/ptp";
import { getPtpStatusConfig } from "./predicate";
import { StyledPTPStatus } from "./styles";
import { PTPStatusSelectProps } from "./type";

function PTPStatusSelect(props: PTPStatusSelectProps) {
  const { value, onChange } = props;
  const updateStatus = useUpdatePTPStatusQuery();
  function handleChange(...args: onSelectChange<PTPStatus>): void {
    onChange?.(...args);
    updateStatus.mutateAsync({ status: args[0] });
  }
  return (
    <StyledPTPStatus
      defaultValue="OPEN"
      css={{ ...getPtpStatusConfig(value) }}
      options={ptpStatusOptions}
      onChange={handleChange}
      value={value}
      loading={updateStatus.isLoading}
    />
  );
}

export { PTPStatusSelect };
